export default __webpack_public_path__ + "static/media/ic_fb.99e3a41e.png";